import { Sparkle } from "lucide-react";

const ITEMS = [
  "Aéroport Nice Côte d'Azur",
  "Cannes — La Croisette",
  "Monaco — Monte-Carlo",
  "Saint-Tropez",
  "Antibes — Juan-les-Pins",
  "Gares de Cannes & Nice",
  "Hôtels & Palaces",
  "Mise à disposition",
];

export const Marquee = () => (
  <section aria-hidden="true" className="overflow-hidden border-y border-slate-200/70 bg-white py-5" data-testid="destinations-marquee">
    <div className="flex w-max animate-marquee">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex items-center">
          {ITEMS.map((item) => (
            <span key={`${copy}-${item}`} className="flex items-center">
              <span className="mx-8 whitespace-nowrap font-serif text-xl italic text-navy/60">{item}</span>
              <Sparkle size={14} className="text-gold" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </section>
);
